import useAdminGroupChatPageElement from '../../../hooks/adminChats/useAdminGroupChatPageElement';

const AdminGroupChatPage = () => useAdminGroupChatPageElement();

export default AdminGroupChatPage;
